import CustomCardTitle from './CustomCardTitle/CustomCardTitle';
import UserProfile from './UserProfile';

export {
  CustomCardTitle
};

export default UserProfile;